import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '../ErrorBoundary';
import { BiEventType } from '../biLogger/constants';
var WatchButton = function (_a) {
    var onClick = _a.onClick, children = _a.children, user = _a.user, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.isWatching, isWatching = _d === void 0 ? false : _d, isWatchingBack = _a.isWatchingBack;
    var t = useTranslation().t;
    var handleClick = function () {
        if (disabled) {
            return;
        }
        onClick(user, isWatching || false);
    };
    var text = isWatching
        ? t('watchButton.watching')
        : isWatchingBack
            ? t('watchButton.watchBack')
            : t('watchButton.watch');
    return (React.createElement(ErrorBoundary, null, children({
        text: text,
        onClick: handleClick,
        disabled: disabled,
        isLoading: isLoading,
        isWatching: isWatching,
        biData: {
            evid: BiEventType.WATCH_AUTHOR,
            is_watching: isWatching ? 0 : 1,
            friendid: user.useridUuid,
        },
    })));
};
WatchButton.displayName = 'WatchButton';
export default WatchButton;
//# sourceMappingURL=WatchButton.js.map